import { useCallback } from 'react'

import { useTrackedRouter } from '@/lib/attribution/useTrackedRouter'
import { trackCtaClick } from '@/lib/gtm/gtmV2'
import { useAuthActions } from '@/lib/hooks/useAuthActions'
import { useAuthInfo } from '@/lib/hooks/useAuthInfo'

import { NavAccountButton } from './NavAccountButton'

export const NavigationLoginButton = () => {
  const { authenticatedUser, isLoading } = useAuthInfo()
  const { logout } = useAuthActions()
  const router = useTrackedRouter()
  const isMemberPortalPage = router.pathname.includes('/account')

  const fullyAuthenticatedOnMemberPortal = !authenticatedUser || authenticatedUser.isAnonymous || isMemberPortalPage

  const handleLogout = useCallback(() => {
    trackCtaClick('account', 'logout-button')
    void logout()
  }, [logout])

  const handleLogin = useCallback(() => {
    trackCtaClick('account', 'login-button')
    void router.push('/login')
  }, [router])

  const handleAccount = useCallback(() => {
    trackCtaClick('account', 'account-button')
    void router.push('/account')
  }, [router])

  if (isLoading) {
    return null
  }

  if (!fullyAuthenticatedOnMemberPortal) {
    return (
      <NavAccountButton
        testId="account-member-portal-icon"
        label="Account"
        icon="person-simple"
        onPress={handleAccount}
      />
    )
  }

  const isLogout = isMemberPortalPage
  return (
    <NavAccountButton
      testId="account-member-portal-login-button"
      label={isLogout ? 'Logout' : 'Login'}
      icon="person-simple"
      onPress={isLogout ? handleLogout : handleLogin}
    />
  )
}
